import { Auth } from 'aws-amplify';

export function startTokenKeepAlive() {
    const EARLY = 5 * 60 * 1000;
    let timer;

    async function schedule() {
        try {
            const session = await Auth.currentSession();
            const access = session.getAccessToken();
            if (!access) {
                timer = setTimeout(schedule, 15 * 60 * 1000);
                return;
            }

            const exp = access.getExpiration() * 1000;
            const msUntilRefresh = exp - Date.now() - EARLY;
            timer = setTimeout(refresh, Math.max(msUntilRefresh, 60 * 1000));
        } catch (e) {
            console.error('Token schedule error', e);
            timer = setTimeout(schedule, 15 * 60 * 1000);
        }
    }

    async function refresh() {
        try {
            await Auth.fetchAuthSession({ forceRefresh: true });
        } catch (e) {
            console.error('Token referesh error', e);
        }finally {
            schedule();
        }
    }

    schedule();
    return () => clearTimeout(timer);
}